class Logger {
    private readonly isDebug: boolean

    constructor() {
        this.isDebug = import.meta.env.DEV
    }

    log(...args: unknown[]): void {
        if (this.isDebug) {
            console.log(...args)
        }
    }

    info(...args: unknown[]): void {
        if (this.isDebug) {
            console.info(...args)
        }
    }

    warn(...args: unknown[]): void {
        if (this.isDebug) {
            console.warn(...args)
        }
    }

    error(...args: unknown[]): void {
        if (this.isDebug) {
            console.error(...args)
        }
    }
}

export const logger = new Logger()